/* import __COLOCATED_TEMPLATE__ from './money-input.hbs'; */
var _dec, _class, _descriptor, _input;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classPrivateFieldSet(e, t, r) { var s = _classPrivateFieldGet2(t, e); return _classApplyDescriptorSet(e, s, r), r; }
function _classApplyDescriptorSet(e, t, l) { if (t.set) t.set.call(e, l);else { if (!t.writable) throw new TypeError("attempted to set read only private field"); t.value = l; } }
function _classPrivateFieldGet(e, t) { var r = _classPrivateFieldGet2(t, e); return _classApplyDescriptorGet(e, r); }
function _classPrivateFieldGet2(s, a) { return s.get(_assertClassBrand(s, a)); }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
function _classApplyDescriptorGet(e, t) { return t.get ? t.get.call(e) : t.value; }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@ember/component';
import { set, action, computed } from '@ember/object';
import { inject as service } from '@ember/service';
import { Money, Currency } from '@square/dashboard-protos/models/squareup/connect/v2/common/money';
function commaSeparated(str) {
  // https://stackoverflow.com/questions/2901102/how-to-print-a-number-with-commas-as-thousands-separators-in-javascript
  return str.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}
function formatMoney(money) {
  const hasCents = money.amount % 100 !== 0; // we'll only display cents if they're not .00
  const dollars = (money.amount / 100).toFixed(hasCents ? 2 : 0);
  return `$${commaSeparated(dollars)}`;
}
function parseMoney(formattedAmount, currency) {
  const parts = formattedAmount.replace(/[$,]/g, '').split('.');
  const dollars = parts[0] || '0';
  let cents = parts[1] || '00';
  if (cents.length === 1) {
    // they typed .1 and they want 10 cents:
    cents += '0';
  }
  const amount = Number.parseInt(dollars, 10) * 100 + (Number.parseInt(cents, 10) || 0);
  return new Money.Builder().amount(amount).currency(currency).build();
}
let MoneyInput = (_dec = computed('userInfo.currencyCode'), _class = (_input = /*#__PURE__*/new WeakMap(), class MoneyInput extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "tagName", '');
    _initializerDefineProperty(this, "userInfo", _descriptor, this);
    // immutable input attr, a Connect v2 Money
    _defineProperty(this, "money", void 0);
    _defineProperty(this, "maxDollars", 999999);
    _defineProperty(this, "showValidation", void 0);
    _defineProperty(this, "validation", void 0);
    _classPrivateFieldInitSpec(this, _input, {
      writable: true,
      value: void 0
    });
    // Internal state we'll modify on input.
    // NOTE: this component, for better or worse, operates textually by editing this string:
    _defineProperty(this, "formattedAmount", '$0');
    // flags if input was typed in (as opposed to input field being directly manipulated)
    _defineProperty(this, "isKeyedIn", false);
  }
  // action we'll fire passing a new Connect v2 Money after processing inputs
  onChange(_) {}
  get currency() {
    return Currency[this.userInfo.currencyCode];
  }

  // FIXME: in Octane, this should be done from this.args.money in constructor()?
  didReceiveAttrs() {
    super.didReceiveAttrs();
    // didReceiveAttrs is called whenever @money changes, so make sure we don't get cycles:
    const currentAmount = parseMoney(this.formattedAmount, this.currency).amount;
    if (this.money && this.money.amount !== currentAmount) {
      set(this, 'formattedAmount', formatMoney(this.money));
    }
    if (this.showValidation) {
      this.setCustomValidity(this.validation);
    }
  }
  applyBackspace() {
    // if you're trying to delete
    if (this.formattedAmount.length > 1 && this.formattedAmount !== '$0') {
      // let you delete anything up until the last character, that should always be a $
      const parts = [...this.formattedAmount];
      parts.pop();
      // get rid of any commas and reformat as needed
      let newNumber = parts.filter(d => d !== ',').join('');
      // if we deleted everything, set to 0
      if (newNumber === '$') {
        newNumber += '0';
      }
      set(this, 'formattedAmount', commaSeparated(newNumber));
    }
  }
  applyNumber(numberKey) {
    const periodIndex = this.formattedAmount.indexOf('.');
    if (periodIndex < 0) {
      // if there's no period, we're typing dollars
      this.applyDollars(numberKey);
    } else if (periodIndex > this.formattedAmount.length - 3) {
      // otherwise we're typing cents
      // if there's still room for more cents, add the requested cent:
      set(this, 'formattedAmount', this.formattedAmount + numberKey);
    }
  }
  applyDollars(numberKey) {
    // transform to just numbers (note that applyNumber enforces that there are no cents inside this function)
    const dollarString = this.formattedAmount.replace(/[$,]/g, '');
    // apply new digit and parse to a Number to strip leading 0:
    const newNumber = Number(dollarString + numberKey);
    if (newNumber > this.maxDollars) {
      // If the new number is too large reject the change.
      return;
    }

    // comma separate and restore dollar sign:
    set(this, 'formattedAmount', `$${commaSeparated(newNumber.toString())}`);
  }
  applyPeriod() {
    // if you're trying to add cents
    if (this.formattedAmount.length > 1 && !this.formattedAmount.includes('.')) {
      // if you don't already have cents, and you're not just a '$'
      set(this, 'formattedAmount', `${this.formattedAmount}.`);
    }
  }
  setCustomValidity(validation) {
    _classPrivateFieldGet(this, _input)?.setCustomValidity(validation.message.toString());
  }
  registerInput(element) {
    _classPrivateFieldSet(this, _input, element);
  }

  // called during typical interactions (i.e. user input from keyboard)
  handleKeyDown(event) {
    try {
      if (event.key === 'Backspace') {
        this.applyBackspace();
      } else if (/\d/.test(event.key)) {
        this.applyNumber(event.key);
      } else if (event.key === '.') {
        this.applyPeriod();
      } else if (event.key === 'Tab' || event.key === 'Enter') {
        // allow tabbing to the submit button, or submitting with Enter
        return;
      } else if (event.ctrlKey || event.metaKey) {
        // capture paste actions and allow them to be handled by handlePaste()
        return;
      }
      // TODO: do we want to handle copy-paste here?
    } catch {
      // TODO: sentry?
    }

    // throw away event, since we should have applied all valid inputs above
    event.preventDefault();

    // ember-test-helpers has a bug where it doesn't acknowledge preventDefault()
    // so set this flag here so we know how to fix things up in handleChange()
    // https://github.com/emberjs/ember-test-helpers/issues/912
    this.isKeyedIn = true;
    this.onChange(parseMoney(this.formattedAmount, this.currency));
  }

  // called when the user attempts to paste into the amount
  handlePaste(event) {
    event.preventDefault();
    const pasteText = event.clipboardData?.getData('Text');

    // only allows numerical values to be paste in
    if (pasteText && /[\d$]/.test(pasteText)) {
      const money = parseMoney(pasteText, this.currency);

      // only allow paste functionality for valid entries
      if (!Number.isNaN(money.amount)) {
        set(this, 'formattedAmount', formatMoney(money));
      }
    }
    this.onChange(parseMoney(this.formattedAmount, this.currency));
  }

  // compensate for bug where ember-test-helpers doesn't respect preventDefault()
  // by syncing the displayed input field value and the internal value
  handleChange(event) {
    const target = event.target;
    if (target.value === this.formattedAmount) {
      // already in sync, nothing to fix here
      return;
    }
    if (this.isKeyedIn) {
      // typing happened, so we've been building the value internally with each keystroke
      // internal value is the source of truth
      target.value = this.formattedAmount;
    } else {
      // no typing happened, meaning input field was manipulated directly
      // the displayed input field value is the source of truth
      const money = parseMoney(target.value, this.currency);
      set(this, 'formattedAmount', formatMoney(money));
      this.onChange(money);
    }
  }
}), _descriptor = _applyDecoratedDescriptor(_class.prototype, "userInfo", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "currency", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "currency"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "registerInput", [action], Object.getOwnPropertyDescriptor(_class.prototype, "registerInput"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleKeyDown", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleKeyDown"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handlePaste", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handlePaste"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleChange", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleChange"), _class.prototype), _class);
export { MoneyInput as default };